export default __webpack_public_path__ + "./fonts/logout.533405e4.svg";